import type { ReactNode } from 'react'

export default function Card({
  children,
  className,
}: {
  children: ReactNode
  className?: string
}) {
  return <div className={`ds-surface p-4 ${className || ''}`}>{children}</div>
}

